import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './features/productsSlice';
import categoriesReducer from './features/categoriesSlice';
import authReducer from './features/authSlice';
import cartReducer from './features/cartSlice';
import wishlistReducer from './features/wishlistSlice';
import ordersReducer from './features/ordersSlice';

export const store = configureStore({
  reducer: {
    products: productsReducer,
    categories: categoriesReducer,
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    orders: ordersReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

